(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adhere-blog"] && !Shopify.designMode) return;
  try {
    
  class AdhereBlogList extends HTMLElement {
    connectedCallback() {
      this.chips = Array.from(this.querySelectorAll('.adhere-blog__chip'));
      this.items = Array.from(this.querySelectorAll('[data-topics]'));
      this.status = this.querySelector('[data-status]');
      this.noResults = this.querySelector('[data-noresults]');
      if (this.chips.length === 0) return;
      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => this.filter(chip));
      });
    }

    filter(chip) {
      const topic = chip.dataset.topic;
      this.chips.forEach((c) => {
        const active = c === chip;
        c.classList.toggle('is-active', active);
        c.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      let visible = 0;
      this.items.forEach((item) => {
        const topics = (item.dataset.topics || '').split(' ');
        const show = topic === 'all' || topics.indexOf(topic) !== -1;
        item.classList.toggle('is-hidden', !show);
        if (show) visible += 1;
      });

      if (this.noResults) this.noResults.hidden = visible !== 0;
      if (this.status) {
        const label = topic === 'all' ? 'all topics' : chip.textContent.trim();
        this.status.textContent = visible + (visible === 1 ? ' article' : ' articles') + ' shown for ' + label + '.';
      }
    }
  }

  if (!customElements.get('adhere-blog-list')) {
    customElements.define('adhere-blog-list', AdhereBlogList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adhere-reviews"] && !Shopify.designMode) return;
  try {
    
  class AdhereReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ar-track]');
      this.prev = this.querySelector('[data-ar-prev]');
      this.next = this.querySelector('[data-ar-next]');
      if (!this.track) return;

      this.prev && this.prev.addEventListener('click', () => this.scrollByCards(-1));
      this.next && this.next.addEventListener('click', () => this.scrollByCards(1));
      this.track.addEventListener('scroll', this.rafUpdate.bind(this), { passive: true });
      window.addEventListener('resize', this.rafUpdate.bind(this), { passive: true });
      this.update();
    }

    cardStep() {
      const card = this.track.firstElementChild;
      if (!card) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || '16') || 16;
      return card.getBoundingClientRect().width + gap;
    }

    scrollByCards(dir) {
      this.track.scrollBy({ left: this.cardStep() * dir, behavior: 'smooth' });
    }

    rafUpdate() {
      cancelAnimationFrame(this._raf);
      this._raf = requestAnimationFrame(this.update.bind(this));
    }

    update() {
      if (!this.prev || !this.next) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      const x = this.track.scrollLeft;
      const overflowing = this.track.scrollWidth > this.track.clientWidth + 4;
      this.prev.disabled = !overflowing || x <= 2;
      this.next.disabled = !overflowing || x >= max;
      this.parentNodeNav();
    }

    parentNodeNav() {
      const nav = this.querySelector('.adhere-reviews__nav');
      if (nav) nav.style.display = (this.track.scrollWidth > this.track.clientWidth + 4) ? '' : 'none';
    }
  }

  if (!customElements.get('adhere-reviews-carousel')) {
    customElements.define('adhere-reviews-carousel', AdhereReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
